import { render, staticRenderFns } from "./affiliateNews.vue?vue&type=template&id=0af1cc61&scoped=true&"
import script from "./affiliateNews.vue?vue&type=script&lang=js&"
export * from "./affiliateNews.vue?vue&type=script&lang=js&"
import style0 from "./affiliateNews.vue?vue&type=style&index=0&id=0af1cc61&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1cc61",
  null
  
)

export default component.exports